export class BuyerContactRequest {
  called?: boolean;
  doorNocked?: boolean;
  noAnswer?: boolean;
  note?: string;
  calledPhoneNumber?: string;
  smsPhoneNumber?: string;
}
